<template>
    <div class="star-contributor-container">
        <ul>
            <li>
                <img src="../../images/star.svg" title="百度开源-gitee" />
                <div class="count-container">
                    <span class="count">{{ star }}</span>
                    <span>Star</span>
                </div>
            </li>
            <li>
                <img src="../../images/Contributor.svg" title="百度开源-gitee" />
                <div class="count-container">
                    <span class="count">{{ contributor }}</span>
                    <span>Contributor</span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            // 默认保存的是2022年1月25日的数据
            star: 377524,
            contributor: 18700
        };
    },
    methods: {
        initStatistics() {
            this.$http.get('/api/project/statistics').then(
                ({data}) => {
                    const status = data.status;
                    if (status === 200) {
                        this.star = data.data.star;
                        this.contributor = data.data.contributors;
                    } else {
                        alert('数据加载失败请重试');
                    }
                }
            );
        }
    },
    created() {
        this.initStatistics();
    }
}
</script>
<style lang="less">
    .star-contributor-container {
        max-width: 1320px;
        margin: 30px auto;
        overflow: hidden;

        ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;

            li{
                display: flex;
                justify-content: center;
                align-items: center;
                list-style-type: none;
                width: 17%;
                margin: 10px 100px;

                .count-container {
                    display: flex;
                    flex-flow: column;
                    justify-content: center;
                    align-items: flex-start;
                    margin-left: 20px;
                    font-size: 16px;
                    color: #666;

                    .count {
                        font-family: DINAlternate-Bold;
                        line-height: 30px;
                        font-size: 24px;
                        color: #000;
                        font-weight: 700;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/common/star-contributor/index.vue